<section class="forgot">
  <div class="panel panel-hero">
    <div class="pre-head slide__right">
      <mat-icon svgIcon="logo-rebillia" class="custom-mat-icon ico-isologo-login"></mat-icon>
    </div>
    <div class="panel-header slide__right">
      <div class="panel-wrapper">
        <h1 class="typo headline semi-condensed fw300 label-title">Forgot your password?</h1>
        <p class="typo body-1 semi-condensed fw300 label-subtitle">Fear not. We’ll email you instructions to reset your password. You may need to check your spam folder or unblock <strong class="fw400">noreply@rebillia.com</strong>.</p>
      </div>
    </div>
    <div class="panel-main slide__right">
      <div class="panel-wrapper">
        <ul>
          <li class="row-form row-message">
            <section class="message message-login" [@messageAnimation]='messageStatus'>
              <div class="message-wrapper" [ngClass]="{'error': resCode == 400, 'success': resCode == 200}">
                <mat-icon *ngIf="resCode == 400" svgIcon="ico-error" class="custom-mat-icon message-icon ico-size ico-sm"></mat-icon>
                <mat-icon *ngIf="resCode == 200" svgIcon="ico-success" class="custom-mat-icon message-icon ico-size ico-sm"></mat-icon>
                <p *ngIf="resCode == 400" class="message-description">Sorry we couldn't find an account neither with that email or username.</p>
                <p *ngIf="resCode == 200" class="message-description">An email with a link to reset your password was sent successfully.</p>
              </div>
            </section>
          </li>
          <li class="row-form row__below__message">
            <mat-form-field appearance="outline" class="size size1of1">
              <mat-label>Email</mat-label>
              <input matInput #email placeholder="Email" color="accent">
            </mat-form-field>
          </li>
          <li class="row-form row-nav align center">
            <mat-list class="custom-mat-list list-simple-nav">
              <mat-list-item class="custom-mat-list-item aside aside-left">
                <button mat-flat-button (click)="onSubmit(email.value)" color="primary" class="custom-mat-button-primary size size1of1 rounded">Reset Password</button>
              </mat-list-item>
              <mat-list-item class="custom-mat-list-item aside">
                <a [routerLink]="['/login/signin']" routerLinkActive="router-link-active"  class="custom-mat-link hasIco active">
                  <mat-icon svgIcon="ico-back" class="custom-mat-icon ico-size ico-3xs"></mat-icon>
                  <span class="ico-label">Return to login</span>
                </a>
              </mat-list-item>
            </mat-list>
          </li>
          <li class="row-form align center">
            <nav class="login-links">
              <ul>
                <li class="nav-opt display inline-block">
                  <a href="https://www.rebillia.com" class="typo caption semi-condensed custom-mat-link active">I can't recover my account using this page.</a>
                </li>
              </ul>
            </nav>
          </li>
          <li class="row-copyright">
            <p class="typo note semi-condensed fw300 fluid-max max-200">©{{ dateYear }} All Rights Reserved. <strong class="typo fw600">Privacy Policy</strong> and <strong class="typo fw600">Terms of Use</strong>.</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
